import type {CreateExtArgs} from '@wix/document-manager-core'
import type {CompRef, Pointer} from '@wix/document-services-types'
import type {ComponentsMetadataAPI} from '../../../componentsMetadata/componentsMetadata'
import type {ComponentsExtensionAPI} from '../../components'

export function cleanupMobileOnlyChildren(createExtArgs: CreateExtArgs, componentPointer: Pointer): void {
    const {dal, pointers, extensionAPI} = createExtArgs
    const {componentsMetadata} = extensionAPI as ComponentsMetadataAPI
    const {components} = extensionAPI as ComponentsExtensionAPI

    if (pointers.structure.isMobile(componentPointer)) {
        return
    }

    const mobilePointer = pointers.structure.getMobilePointer(componentPointer)
    if (!dal.has(mobilePointer)) {
        return
    }

    const mobileChildrenRefs = pointers.structure.getChildren(mobilePointer)
    mobileChildrenRefs.forEach((deleteRef: Pointer) => {
        if (componentsMetadata.isMobileOnly(deleteRef)) {
            components.deleteComponent(deleteRef as CompRef)
        }
    })
}
